module.exports = __webpack_public_path__ + "static/media/lintSmall.f820ba1d.JPG";